if (typeof DiscountNotice !== "function") {
  var discountStorage = (key, value) => {
    var lsSupport = false;

    // Check for native support
    if (localStorage) {
      lsSupport = true;
    }
    lsSupport = false;

    // If value is detected, set new or modify store
    if (typeof value !== "undefined" && value !== null) {
      // Convert object values to JSON
      if (typeof value === "object") {
        value = JSON.stringify(value);
      }
      // Set the store
      if (lsSupport) {
        // Native support
        localStorage.setItem(key, value);
      } else {
        // Use Cookie
        createCookie(key, value, 1);
      }
    }

    // No value supplied, return value
    if (typeof value === "undefined") {
      // Get value
      if (lsSupport) {
        // Native support
        data = localStorage.getItem(key);
      } else {
        // Use cookie
        data = readCookie(key);
      }

      // Try to parse JSON...
      try {
        data = JSON.parse(data);
      } catch (e) {
        data = data;
      }

      return data;
    }

    // Null specified, remove store
    if (value === null) {
      if (lsSupport) {
        // Native support
        localStorage.removeItem(key);
      } else {
        // Use cookie
        createCookie(key, "", -1);
      }
    }

    /**
     * Creates new cookie or removes cookie with negative expiration
     * @param  key       The key or identifier for the store
     * @param  value     Contents of the store
     * @param  exp       Expiration - creation defaults to 30 days
     */

    function createCookie(key, value, exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000); // exp days
      var expires = "; expires=" + date.toGMTString();
      document.cookie = key + "=" + value + expires + "; path=/";
    }

    /**
     * Returns contents of cookie
     * @param  key       The key or identifier for the store
     */

    function readCookie(key) {
      var nameEQ = key + "=";
      var ca = document.cookie.split(";");
      for (var i = 0, max = ca.length; i < max; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  };

  class DiscountNotice extends HTMLElement {
    constructor() {
      super();
      this.initialize();
      this.count = 0;
    }

    async initialize() {
      // Verstecke die Notiz standardmäßig
      this.style.display = "none";
      let $this = this;

      // Hole den Rabattcode ausschließlich aus dem Warenkorb
      const discountCode = await this.getDiscountCodeFromCart();

      // Wenn kein Rabattcode im Warenkorb gefunden wurde, zeige nichts an
      if (!discountCode) {
        $this.count += 1;
        setTimeout(() => {
          $this.initialize();
        }, $this.count * 2000);
        return;
      }

      // Wenn ein Rabattcode gefunden wurde, zeige die Notiz an
      const text = this.querySelector(".ds-discount-notice__text");
      if (text) {
        let coupon_code = discountCode.toString().toUpperCase();

        // Entferne eventuelle Parameter nach einem &
        coupon_code = coupon_code.split("&")[0];

        // Ersetze den Platzhalter [code] mit dem tatsächlichen Code
        const templateText = text.innerHTML;
        text.innerHTML = templateText.replace("[code]", coupon_code);

        // Zeige die Notiz an
        this.style.display = "block";

        // Speichere den Code für zukünftige Verwendung
        // discountStorage("discount_code_referrer", discountCode);
      }
    }

    async getDiscountCodeFromCart() {
      try {
        // Fetch den aktuellen Warenkorb
        const response = await fetch("/cart.js", { cache: "no-store" });
        if (!response.ok) {
          console.error(
            "Fehler beim Abrufen des Warenkorbs:",
            response.statusText
          );
          return null;
        }

        const cartData = await response.json();
        console.log("Cart data discount code:", cartData);

        // Prüfe, ob der Warenkorb Rabattcodes enthält
        // if (
        //   cartData &&
        //   cartData.discount_codes &&
        //   cartData.discount_codes.length > 0
        // ) {
        //   // Nimm einfach den ersten Code, unabhängig davon, ob er anwendbar ist oder nicht
        //   const discountCode = cartData.discount_codes[0];
        //   console.log(
        //     "Rabattcode aus Warenkorb gefunden:",
        //     discountCode.code,
        //     "Anwendbar:",
        //     discountCode.applicable
        //   );
        //   return discountCode.code;
        // }

        const cookieDiscountcode = this.getCookie("discount_code");
        const cookieDiscountcodeDate = this.getCookie("discount_code_date");
        const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD

        console.log({cookieDiscountcode, cookieDiscountcodeDate, today});

        // Wenn ein Discount-Code existiert
        if (cookieDiscountcode) {
          // Fall 1: Datum existiert und ist heute - alles in Ordnung, Code zurückgeben
          if (cookieDiscountcodeDate && cookieDiscountcodeDate === today) {
            return cookieDiscountcode;
          } 
          // Fall 2: Datum existiert, ist aber nicht heute - Cookie ist abgelaufen
          else if (cookieDiscountcodeDate && cookieDiscountcodeDate !== today) {
            // Cookie löschen, da er abgelaufen ist
            this.deleteCookie("discount_code");
            this.deleteCookie("discount_code_date");
            console.log("Cookie gelöscht, da abgelaufen. Datum:", cookieDiscountcodeDate, "Heute:", today);
            return null;
          }
          // Fall 3: Kein Datum gesetzt - Cookie-Datum setzen
          else {
            // Setze das Cookie-Datum mit dem heutigen Datum und 1 Tag Gültigkeit
            this.setCookie("discount_code", cookieDiscountcode, 1);
            this.setCookie("discount_code_date", today, 1);
            console.log("Cookie-Datum gesetzt:", today);
            return cookieDiscountcode;
          }
        }

        // Kein Discount-Code gefunden
        return null;
      } catch (error) {
        console.error("Fehler beim Verarbeiten des Warenkorbs:", error);
        return null;
      }
    }

    getCookie(name) {
      return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
      }, "");
    }

    setCookie(name, value, exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000); // exp days
      var expires = "; expires=" + date.toGMTString();
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    deleteCookie(name) {
      // Cookie löschen durch Setzen eines abgelaufenen Datums
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }

  if (typeof customElements.get("discount-notice") == "undefined") {
    customElements.define("discount-notice", DiscountNotice);
  }
}
